import type CalculationPosition from '../../../../types/api/calculation-position'
import { Badge, Flex, Popover, Space } from 'antd'
import MaterialTypesWrapper from '../../components/calculation-form/components/form-items/material-types-wrapper'
import { renderCalcPos } from '../../helpers/helpers'
import isCalculation from '../../helpers/is-calculation'
import MaterialType from '../../../../types/api/material-type'
import type { CalculationColumn } from '../../types/column-types'
import formatNumber from '../../../../helpers/formatters/format-any-number'

export const materialTypeNameColumn: CalculationColumn = {
    dataIndex: ['material_type', 'name'],
    fieldDescriptors: [
        {
            name: ['material_type', 'set'],
            getValue: (record: CalculationPosition) => record.material_type?.documentId,
        },
        {
            name: ['additional_material_types', 'set'],
            getValue: (record: CalculationPosition) =>
                record.additional_material_types?.map((item: MaterialType) => item.documentId),
        },
        {
            name: ['material', 'set'],
            getValue: (record: CalculationPosition) => record.material?.documentId,
        },
        {
            name: ['additional_materials', 'set'],
            getValue: (record: CalculationPosition) =>
                record.additional_materials?.map(item => item.documentId),
        },
    ],
    title: 'Материал',
    // width: 100,
    editable: true,
    FormItem: <MaterialTypesWrapper />,
    onCell: record => {
        if (isCalculation(record)) {
            return { colSpan: 40, editable: false }
        } else {
            return { colSpan: 1, style: { maxWidth: 70 } }
        }
    },
    render: renderCalcPos(r => {
        const list: MaterialType[] = []
        if (r.material_type) list.push(r.material_type)
        if (r.additional_material_types) list.push(...r.additional_material_types)
        return (
            <Popover
                content={
                    <Space direction={'vertical'} style={{ minWidth: 200 }}>
                        {list?.map(v => (
                            <Flex
                                key={v.documentId}
                                justify='space-between'
                                gap={12}
                                style={{ width: '100%' }}
                            >
                                <span>{v.name}</span>
                                {v.cost != null ? <span>{formatNumber(v.cost)}</span> : null}
                            </Flex>
                        ))}
                    </Space>
                }
                placement={'bottomLeft'}
            >
                {(list?.length || 0) > 1 ? <Badge count={list?.length} /> : null}{' '}
                {list?.map(v => v.name).join(', ')}
            </Popover>
        )
    }),
}
